/**
 * Banner hero slider — crossfades the figure's stacked images and wires the
 * dot navigation. Frontend only: banner.php emits [data-banner-slider] (and
 * the extra slides) outside the editor, where the hero stays a static slide 1
 * with a management strip — so there's no hot-patch re-init concern here.
 */
document.querySelectorAll("[data-banner-slider]").forEach((banner) => {
	const slides = banner.querySelectorAll(":scope > figure img");
	const dots = banner.querySelectorAll(".bannerDots button");
	if (slides.length < 2) return;

	let current = 0;
	let timer = null;

	const show = (next) => {
		slides[current].classList.remove("is-active");
		dots[current]?.classList.remove("is-active");
		current = (next + slides.length) % slides.length;
		slides[current].classList.add("is-active");
		dots[current]?.classList.add("is-active");
	};

	const stop = () => timer && clearInterval(timer);
	const start = () => {
		if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
		timer = setInterval(() => show(current + 1), 6000);
	};

	dots.forEach((dot, i) => {
		dot.addEventListener("click", () => {
			stop();
			show(i);
			start();
		});
	});

	start();
});
